<script lang="ts">
    import Overlay from "../Overlay.svelte";
    import { fly } from "svelte/transition";
    import { getMessage } from "@app/services/i18n.service";
    import {
        COMMON__logIn,
        COMMON__register,
        COMMON__logout,
        FOOTER__about__link,
        FOOTER__contact__link,
        FOOTER__partners__link,
        NAVIGATION__home__link,
        NAVIGATION__languages__link,
        NAVIGATION__welcomeUnloggedText,
        USER__userProfileLink,
        COMMON__settings,
        NAVIGATION__Notifications,
        COMMON__Favorite_translations,
        COMMON__Recently_viewed_translations,
    } from "@app/services/i18n.messages";
    import isPageRtl from "../IsPageRtl";
    import MessageIcon from "../Icons/MessageIcon.svelte";
    import NotificationsMarker from "../Notifications/NotificationsMarker.svelte";
    import HomeIcon from "../Icons/HomeIcon.svelte";
    import ArrowRightOnRectangle from "../Icons/ArrowRightOnRectangleIcon.svelte";
    import ListBulletsIcon from "../Icons/ListBulletsIcon.svelte";
    import UserGroupIcon from "../Icons/UserGroupIcon.svelte";
    import ChatBubbleLeftRightIcon from "../Icons/ChatBubbleLeftRightIcon.svelte";
    import InformationCircleIcon from "../Icons/InformationCircleIcon.svelte";
    import SettingsIcon from "../Icons/SettingsIcon.svelte";
    import ArrowLeftOnRectangleIcon from "../Icons/ArrowLeftOnRectangleIcon.svelte";
    import XMarkIcon from "../Icons/XMarkIcon.svelte";
    import HeartIcon from "../Icons/HeartIcon.svelte";
    import HistoryIcon from "../Icons/HistoryIcon.svelte";

    export let open: boolean = false;
    export let onClose: () => void;
    let isRtl = isPageRtl();

    const x = isRtl ? (5 * window.innerWidth) / 4 : -(window.innerWidth / 4);

    let isLoggedIn = false;
    let user: { name: string; avatar: string; id: string } | undefined;
    let avatarHtml = "";
    const userNameElement = document.getElementById("navbar__user__name");
    let loginHref = "";
    if (userNameElement) {
        let name = userNameElement.textContent.trim();
        let avatar: string;
        let id = document.getElementById("navbar__user").dataset["userid"];
        if (name) {
            isLoggedIn = true;
            let avatarElement = document.querySelector<HTMLImageElement>(
                "#navbar__user__avatar img"
            );
            if (avatarElement && avatarElement.src) {
                avatar = avatarElement.src.trim();
                avatarHtml = avatarElement.innerHTML;
            }
        }

        user = { name, avatar, id };
    }

    const loginLinkElement = document.getElementById(
        "navbar__login"
    ) as HTMLAnchorElement;
    if (loginLinkElement) {
        loginHref = loginLinkElement.href;
    }

    const navListItemClass = "";
    const navListItemElementClass =
        "w-full h-full block  py-2 text-left text-primary-600 hover:underline flex items-center";
    const redirectUrl = window.location.toString();
    let logoutUrl =
        (window as any).glosbe?.logoutUrl ||
        "https://auth2.glosbe.com/doLogout";
</script>

{#if open}
    <Overlay onClick={onClose} center={false}>
        <aside
            class="fixed overflow-scroll w-full sm:w-1/2 md:w-1/4 lg:w-1/5 h-full bg-white text-sm
      shadow-lg"
            transition:fly={{ x: x, opacity: 1 }}
        >
            <nav>
                <div class=" text-2xl px-2 flex items-center h-12 bg-white">
                    <button
                        class="inline-block w-8 h-8 flex items-center justify-center"
                        on:click={onClose}
                    >
                        <XMarkIcon />
                    </button>
                    <span class="inline-block px-2">
                        <img
                            class="object-contain w-6 h-6 overflow-hidden"
                            src="/assets/images/glosbe-logo-bird-2.svg"
                            alt="Glosbe bird"
                        />
                    </span>
                    <span class="text-gray-900">Glosbe</span>
                </div>
                <div class="">
                    <ul class="px-4 border-gray-300 border bg-gray-100 py-4">
                        {#if isLoggedIn}
                            <li class={navListItemClass}>
                                <a
                                    class={`${navListItemElementClass}`}
                                    href="/profile/{user.id}"
                                >
                                    <img
                                        src={user.avatar}
                                        alt={user.name}
                                        class="w-6 h-6 inline"
                                        width="1.25rem"
                                        height="1.25rem"
                                    />
                                    <div class="px-2">
                                        {getMessage(USER__userProfileLink)} ({user.name})
                                    </div>
                                </a>
                            </li>
                            <li class={navListItemClass}>
                                <a
                                    class={`${navListItemElementClass}`}
                                    href="/notifications"
                                >
                                    <span class="w-6">
                                        <MessageIcon
                                            width="1.25rem"
                                            height="1.25rem"
                                        />
                                    </span>
                                    <div class="px-2">
                                        {getMessage(NAVIGATION__Notifications)}
                                    </div>
                                    <div class="relative">
                                        <NotificationsMarker />
                                    </div>
                                </a>
                            </li>
                            <li class={navListItemClass}>
                                <form action={logoutUrl} method="post">
                                    <input
                                        name="returnUrl"
                                        value={redirectUrl}
                                        type="hidden"
                                    />
                                    <button class={navListItemElementClass}>
                                        <span class="w-6">
                                            <ArrowRightOnRectangle
                                                width="1.25rem"
                                                height="1.25rem"
                                            />
                                        </span>
                                        <span class="block px-2">
                                            {getMessage(COMMON__logout)}
                                        </span>
                                    </button>
                                </form>
                            </li>
                        {:else}
                            <li class={navListItemClass}>
                                <p
                                    class="font-medium text-lg text-primary-900 py-2"
                                >
                                    {getMessage(
                                        NAVIGATION__welcomeUnloggedText
                                    )}
                                </p>
                            </li>
                            <li class={navListItemClass}>
                                <a
                                    class={navListItemElementClass}
                                    href={loginHref}
                                >
                                    <span class="w-6"
                                        ><ArrowLeftOnRectangleIcon
                                            width="1.25rem"
                                            height="1.25rem"
                                        /></span
                                    >
                                    <span class="inline-block px-2">
                                        {getMessage(COMMON__logIn)} / {getMessage(
                                            COMMON__register
                                        )}
                                    </span>
                                </a>
                            </li>
                        {/if}
                    </ul>
                </div>
                <div>
                    <ul class="px-4 border-gray-300">
                        <li class={navListItemClass}>
                            <a class={navListItemElementClass} href="/settings">
                                <span class="w-6"
                                    ><SettingsIcon
                                        width="1.25rem"
                                        height="1.25rem"
                                    /></span
                                >

                                <div class="inline-block px-2">
                                    {getMessage(COMMON__settings)}
                                </div>
                            </a>
                        </li>
                    </ul>
                </div>
                <div class="px-4">
                    <ul class="">
                        <li class={navListItemClass}>
                            <a
                                class={navListItemElementClass}
                                href="/user/favoriteTranslations"
                            >
                                <span class="w-6">
                                    <HeartIcon
                                        width="1.25rem"
                                        height="1.25rem"
                                    />
                                </span>
                                <span class="inline-block px-2"
                                    >{getMessage(
                                        COMMON__Favorite_translations
                                    )}</span
                                >
                            </a>
                        </li>
                        <li class={navListItemClass}>
                            <a
                                class={navListItemElementClass}
                                href="/user/recentlyViewed"
                            >
                                <span class="w-6">
                                    <HistoryIcon
                                        width="1.25rem"
                                        height="1.25rem"
                                    />
                                </span>
                                <span class="inline-block px-2"
                                    >{getMessage(
                                        COMMON__Recently_viewed_translations
                                    )}</span
                                >
                            </a>
                        </li>
                        <li class={navListItemClass}>
                            <a class={navListItemElementClass} href="/">
                                <span class="w-6">
                                    <HomeIcon
                                        width="1.25rem"
                                        height="1.25rem"
                                    />
                                </span>
                                <span class="inline-block px-2"
                                    >{getMessage(NAVIGATION__home__link)}</span
                                >
                            </a>
                        </li>
                        <li class={navListItemClass}>
                            <a
                                class={navListItemElementClass}
                                href="/all-languages"
                            >
                                <span class="w-6">
                                    <ListBulletsIcon
                                        width="1.25rem"
                                        height="1.25rem"
                                    />
                                </span>
                                <span class="inline-block px-2"
                                    >{getMessage(
                                        NAVIGATION__languages__link
                                    )}</span
                                >
                            </a>
                        </li>
                        <li class={navListItemClass}>
                            <a class={navListItemElementClass} href="/about">
                                <span class="w-6">
                                    <InformationCircleIcon
                                        width="1.25rem"
                                        height="1.25rem"
                                    />
                                </span>
                                <span class="inline-block px-2"
                                    >{getMessage(FOOTER__about__link)}</span
                                >
                            </a>
                        </li>
                        <li class={navListItemClass}>
                            <a class={navListItemElementClass} href="/partners">
                                <span class="w-6">
                                    <UserGroupIcon
                                        width="1.25rem"
                                        height="1.25rem"
                                    />
                                </span>
                                <span class="inline-block px-2"
                                    >{getMessage(FOOTER__partners__link)}</span
                                >
                            </a>
                        </li>
                        <li class={navListItemClass}>
                            <a class={navListItemElementClass} href="/contact">
                                <span class="w-6">
                                    <ChatBubbleLeftRightIcon
                                        width="1.25rem"
                                        height="1.25rem"
                                    />
                                </span>
                                <span class="inline-block px-2"
                                    >{getMessage(FOOTER__contact__link)}</span
                                >
                            </a>
                        </li>
                    </ul>
                </div>
            </nav>
        </aside>
    </Overlay>
{/if}
